import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormDataService {

  private cleanInputForm = new BehaviorSubject<boolean>(false);
  currentState = this.cleanInputForm.asObservable();

  private cleanPackages = new BehaviorSubject<boolean>(false);
  currentRemovePackages = this.cleanPackages.asObservable();

  constructor() { }

  changeState(state: boolean){
    this.cleanInputForm.next(state);
  }

  changePackageState(removePackages: boolean){
    this.cleanPackages.next(removePackages);
  }

}
